// import React from "react";
// import { Container, Row, Col, Form, Button } from "react-bootstrap";
// import {
//   FaFacebookF,
//   FaTwitter,
//   FaInstagram,
//   FaLinkedinIn,
//   FaYoutube,
//   FaMapMarkerAlt,
//   FaPhone,
//   FaEnvelope,
// } from "react-icons/fa";
// import "../../assets/css/FooterSection.css";
// import logo from '../../assets/Radheshyam-Full-logo1-01.png'

// const FooterSection = () => {
//   return (
//     <footer id="footerSection">
//       {/* Footer Top */}
//       <div className="footer-top">
//         <Container>
//           <Row>
//             <Col md={4} className="contact-info">
//               <div className="contact-item">
//                 <div className="icon-circle">
//                   <FaMapMarkerAlt />
//                 </div>
//                 <h6>Our Offices</h6>
//                 <p>
//                   Located in the country, ready to assist in planning & booking
//                   your perfect vacation.
//                 </p>
//                 <a href="#" className="contact-link">
//                   Locate Us
//                 </a>
//               </div>
//             </Col>

//             <Col md={4} className="contact-info">
//               <div className="contact-item">
//                 <div className="icon-circle">
//                   <FaPhone />
//                 </div>
//                 <h6>Call us</h6>
//                 <p>
//                   Request a quote, or just chat about your next vacation. We're
//                   always happy to help!
//                 </p>
//                 <a href="tel:1800227979" className="contact-link">
//                   1800 22 7979
//                 </a>
//               </div>
//             </Col>

//             <Col md={4} className="contact-info">
//               <div className="contact-item">
//                 <div className="icon-circle">
//                   <FaEnvelope />
//                 </div>
//                 <h6>Write to us</h6>
//                 <p>Be it an enquiry, feedback or a simple suggestion.</p>
//                 <a
//                   href="mailto:travel@RadheShyamworld.com"
//                   className="contact-link"
//                 >
//                   travel@RadheShyamworld.com
//                 </a>

//                 <h6 className="mt-4">Connect with us</h6>
//                 <div className="social-icons">
//                   <a href="#" aria-label="Facebook">
//                     <FaFacebookF />
//                   </a>
//                   <a href="#" aria-label="Twitter">
//                     <FaTwitter />
//                   </a>
//                   <a href="#" aria-label="Instagram">
//                     <FaInstagram />
//                   </a>
//                   <a href="#" aria-label="LinkedIn">
//                     <FaLinkedinIn />
//                   </a>
//                   <a href="#" aria-label="YouTube">
//                     <FaYoutube />
//                   </a>
//                 </div>
//               </div>
//             </Col>
//           </Row>
//         </Container>
//       </div>

//       {/* Footer Main */}
//       <div className="footer-main">
//         <Container>
//           <Row>
//             <Col md={3} className="logo-section">
//               <div className="logo-wrapper">
//                 <img
//                src={logo}
//                 />
//               </div>

//               <p className="subscribe-text">
//                 Keep travelling all year round! Subscribe to our newsletter to
//                 find inspiration in your inbox.
//               </p>

//               <Form className="newsletter-form">
//                 <Form.Group>
//                   <Form.Control type="text" placeholder="FULL NAME" required />
//                 </Form.Group>

//                 <Form.Group>
//                   <Form.Control type="email" placeholder="EMAIL ID" required />
//                 </Form.Group>

//                 <Form.Group>
//                   <Form.Control
//                     type="tel"
//                     placeholder="MOBILE NUMBER"
//                     pattern="[0-9]{10}"
//                     required
//                   />
//                 </Form.Group>

//                 <Button type="submit" className="subscribe-btn">
//                   Subscribe
//                 </Button>
//               </Form>

//               <div className="associations">
//                 <img
//                   src="https://via.placeholder.com/40x30?text=IATA"
//                   alt="IATA"
//                 />
//                 <img
//                   src="https://via.placeholder.com/40x30?text=TAFI"
//                   alt="TAFI"
//                 />
//                 <img
//                   src="https://via.placeholder.com/40x30?text=TAAI"
//                   alt="TAAI"
//                 />
//               </div>
//             </Col>

//             <Col md={3} className="footer-column">
//               <h6>Discover us</h6>
//               <ul className="footer-links">
//                 <li>
//                   <a href="#">Guests Reviews</a>
//                 </li>
//                 <li>
//                   <a href="#">About Us</a>
//                 </li>
//                 <li>
//                   <a href="#">Our Team</a>
//                 </li>
//                 <li>
//                   <a href="#">Tour Managers</a>
//                 </li>
//                 <li>
//                   <a href="#">Sales Partners</a>
//                 </li>
//                 <li>
//                   <a href="#">Become A Sales Partner</a>
//                 </li>
//                 <li>
//                   <a href="#">Careers We're Hiring!</a>
//                 </li>
//                 <li>
//                   <a href="#">CSR Policy</a>
//                 </li>
//                 <li>
//                   <a href="#">Create Your Travel Portfolio</a>
//                 </li>
//               </ul>
//             </Col>

//             <Col md={3} className="footer-column">
//               <h6>Support</h6>
//               <ul className="footer-links">
//                 <li>
//                   <a href="#">Contact Us</a>
//                 </li>
//                 <li>
//                   <a href="#">Leave Your Feedback</a>
//                 </li>
//                 <li>
//                   <a href="#">FAQ</a>
//                 </li>
//                 <li>
//                   <a href="#">Travel Deals</a>
//                 </li>
//                 <li>
//                   <a href="#">COVID-19 Public Notice</a>
//                 </li>
//                 <li>
//                   <a href="#">Singapore Visa</a>
//                 </li>
//                 <li>
//                   <a href="#">Disclosure</a>
//                 </li>
//               </ul>
//             </Col>

//             <Col md={3} className="footer-column">
//               <h6>Resources</h6>
//               <ul className="footer-links">
//                 <li>
//                   <a href="#">Tour Status</a>
//                 </li>
//                 <li>
//                   <a href="#">Blog</a>
//                 </li>
//                 <li>
//                   <a href="#">Podcasts</a>
//                 </li>
//                 <li>
//                   <a href="#">Video Blogs</a>
//                 </li>
//                 <li>
//                   <a href="#">Travel Planners</a>
//                 </li>
//               </ul>
//             </Col>
//           </Row>
//         </Container>
//       </div>

//       {/* Footer Bottom */}
//       <div className="footer-bottom">
//         <Container>
//           <div className="caution-note">
//             <p>
//               *CAUTION: BEWARE OF FAKE PROMOTIONS OR OFFERS. PLEASE DO NOT
//               BELIEVE OR ENGAGE WITH ANY PROMOTIONAL EMAILS, SMS OR WEB-LINK
//               WHICH ASK YOU TO CLICK ON A LINK AND FILL IN YOUR DETAILS. ALL
//               Radhe Shyam WORLD AUTHORIZED EMAIL COMMUNICATIONS ARE DELIVERED
//               FROM DOMAIN @RadheShyamWORLD.COM OR @RadheShyamWORLD.IN OR SMS
//               FROM VNAWLD OR 743124. 'Radhe Shyam WORLD' BEARS NO LIABILITY OR
//               RESPONSIBILITY WHATSOEVER FOR ANY COMMUNICATION WHICH IS
//               FRAUDULENT OR MISLEADING IN NATURE AND NOT RECEIVED FROM
//               REGISTERED DOMAIN.
//             </p>
//           </div>

//           <div className="copyright-section">
//             <p>© 2013 - 25 Radhe Shyam Pvt. Ltd. All Rights Reserved.</p>

//             <div className="bottom-links">
//               <a href="#">Privacy Policy</a>
//               <a href="#">Terms & Conditions</a>
//               <a href="#">Sitemap</a>
//             </div>

//             <div className="payment-note">Payments on website are SECURE</div>
//           </div>
//         </Container>
//       </div>
//     </footer>
//   );
// };

// export default FooterSection;


// import React from "react";
// import { Container, Row, Col, Form } from "react-bootstrap";
// import { 
//   FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube, 
//   FaPaperPlane, FaMapMarkerAlt, FaPhoneAlt, FaEnvelopeOpen 
// } from "react-icons/fa";
// import "../../assets/css/FooterSection.css";
// import logo from '../../assets/Radheshyam-Full-logo1-01.png';

// const FooterSection = () => {
//   return (
//     <footer className="modern-footer">
//       {/* --- Floating Contact Bar --- */}
//       <div className="contact-floating-bar">
//         <Container>
//           <div className="glass-card-container shadow-lg">
//             <Row className="align-items-center g-0">
//               <Col md={4} className="contact-col border-end-glass">
//                 <div className="d-flex align-items-center p-4">
//                   <div className="icon-gradient"><FaMapMarkerAlt /></div>
//                   <div className="ms-3">
//                     <p className="label-text">Visit Us</p>
//                     <p className="value-text">Vadodara, Gujarat, India</p>
//                   </div>
//                 </div>
//               </Col>
//               <Col md={4} className="contact-col border-end-glass">
//                 <div className="d-flex align-items-center p-4">
//                   <div className="icon-gradient"><FaPhoneAlt /></div>
//                   <div className="ms-3">
//                     <p className="label-text">Call Anytime</p>
//                     <p className="value-text">1800 22 7979</p>
//                   </div>
//                 </div>
//               </Col>
//               <Col md={4} className="contact-col">
//                 <div className="d-flex align-items-center p-4">
//                   <div className="icon-gradient"><FaEnvelopeOpen /></div>
//                   <div className="ms-3">
//                     <p className="label-text">Email Support</p>
//                     <p className="value-text">travel@RadheShyam.com</p>
//                   </div>
//                 </div>
//               </Col>
//             </Row>
//           </div>
//         </Container>
//       </div>

//       {/* --- Main Footer Content --- */}
//       <div className="footer-content-area">
//         <Container>
//           <Row className="gy-5">
//             <Col lg={4} md={12}>
//               <img src={logo} alt="Logo" className="footer-brand-logo mb-4" />
//               <p className="footer-desc">
//                 Crafting extraordinary travel experiences and luxury real estate projects since 2013. We don't just build, we create memories.
//               </p>
//               <div className="modern-socials">
//                 <a href="#" className="social-box"><FaFacebookF /></a>
//                 <a href="#" className="social-box"><FaInstagram /></a>
//                 <a href="#" className="social-box"><FaLinkedinIn /></a>
//                 <a href="#" className="social-box"><FaYoutube /></a>
//               </div>
//             </Col>

//             <Col lg={2} md={4} className="ps-lg-5">
//               <h5 className="footer-heading">Company</h5>
//               <ul className="footer-nav">
//                 <li><a href="#">Our Story</a></li>
//                 <li><a href="#">Travel Blog</a></li>
//                 <li><a href="#">Our Team</a></li>
//                 <li><a href="#">Career</a></li>
//               </ul>
//             </Col>

//             <Col lg={2} md={4}>
//               <h5 className="footer-heading">Services</h5>
//               <ul className="footer-nav">
//                 <li><a href="#">International Tours</a></li>
//                 <li><a href="#">Domestic Packages</a></li>
//                 <li><a href="#">Visa Assistance</a></li>
//                 <li><a href="#">Real Estate</a></li>
//               </ul>
//             </Col>

//             <Col lg={4} md={4}>
//               <h5 className="footer-heading">Stay Inspired</h5>
//               <p className="small opacity-75">Subscribe to get travel tips and exclusive offers.</p>
//               <div className="modern-newsletter mt-3">
//                 <input type="email" placeholder="Your Email..." />
//                 <button><FaPaperPlane /></button>
//               </div>
//             </Col>
//           </Row>
//         </Container>
//       </div>

//       {/* --- Bottom Bar --- */}
//       <div className="footer-legal-bar mt-5">
//         <Container>
//           <hr className="footer-divider" />
//           <div className="d-md-flex justify-content-between py-4 text-center text-md-start">
//             <p className="copyright-text">© 2026 Radhe Shyam Group. Built with Love.</p>
//             <div className="legal-links">
//               <a href="#">Privacy</a>
//               <a href="#">Terms</a>
//               <a href="#">Sitemap</a>
//             </div>
//           </div>
//         </Container>
//       </div>
//     </footer>
//   );
// };

// export default FooterSection;

import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { 
  FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube, 
  FaPaperPlane, FaMapMarkerAlt, FaPhoneAlt, FaEnvelopeOpen 
} from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import "../../assets/css/FooterSection.css";
import logo from '../../assets/Radheshyam-Full-logo1-01.png';
import BASE_URL from "../commanfile";

const FooterSection = ({ footerData, chardhamData, tourSector }) => {
  const navigate = useNavigate();
  const office = footerData?.ourOffice?.[0] || {};
  const chardhamPackages = chardhamData?.[0]?.tourDetails || [];

  const getImageUrl = (imgPath) => {
    return imgPath ? `${BASE_URL}/api/image?file=${encodeURIComponent(imgPath.substring(1))}` : logo;
  };

  return (
    <footer className="modern-footer">
      {/* --- Floating Contact Bar --- */}
      <div className="contact-floating-bar">
        <Container>
          <div className="glass-card-container shadow-lg">
            <Row className="align-items-center g-0">
              <Col md={4} className="contact-col border-md-end">
                <div className="contact-item">
                  <div className="icon-gradient"><FaMapMarkerAlt /></div>
                  <div className="px-3">
                    <p className="label-text text-white">Visit Us</p>
                    <p className="value-text text-truncate text-white">{office.name || "Radheshyam Travels"}</p>
                  </div>
                </div>
              </Col>
              <Col md={4} className="contact-col border-md-end">
                <div className="contact-item">
                  <div className="icon-gradient"><FaPhoneAlt /></div>
                  <div className="px-3">
                    <p className="label-text text-white">Call Anytime</p>
                    <p className="value-text text-white">{office.phone?.split('|')[0] || "079 2644 3778"}</p>
                  </div>
                </div>
              </Col>
              <Col md={4} className="contact-col">
                <div className="contact-item">
                  <div className="icon-gradient"><FaEnvelopeOpen /></div>
                  <div className="px-3">
                    <p className="label-text text-white">Email Support</p>
                    <p className="value-text text-truncate text-white">{office.email?.split('|')[0] || "info@radheshyam.com"}</p>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>

      <div className="footer-content-area">
        <Container>
          <Row className="gy-5">
            {/* Column 1: Brand */}
        <Col lg={3} md={6}>
  <div className="footer-logo-box mb-4">
    <img src={logo} alt="Radheshyam Logo" className="footer-brand-logo" />
  </div>

  <p className="footer-desc">
    Specializing in spiritual journeys and premium travel experiences across India since 2013.
  </p>

  <div className="modern-socials">
    {footerData?.socialMedia?.map((item, index) => (
      <div
        key={index}
        className="social-box"
        onClick={() => window.open(item.link, "_blank")}
      >
        <Image  src={item.iconLink}  alt={item.type} className="social-icon"         style={{ width: "24px", height: "24px", objectFit: "contain" }}
 />
        
      </div>
    ))}
  </div>
</Col>


            {/* Column 2: Chardham */}
            <Col lg={2} md={6}>
              <h5 className="footer-heading">{chardhamData?.[0]?.menuName}</h5>
              <ul className="footer-nav">
                {chardhamPackages.slice(0, 4).map((pkg) => (
                  <li key={pkg.id} className="footer-nav-item">
                    <Link to={`/tour-details/${pkg.type == "fit" ? `fit-${pkg.id}` : `${pkg.id}`}`} className="d-flex align-items-center">
                      <span>{pkg.name.split('–')[0]}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </Col>

            {/* Column 3: Popular Destinations */}
            <Col lg={4} md={6}>
              <h5 className="footer-heading">Popular Destinations</h5>
              <div className="destinations-grid">
                {tourSector?.slice(0, 2).map((typeObj, typeIndex) => (
                  <div className="dest-group" key={typeIndex}>
                    <h6 className="dest-subheading">{typeObj.type}</h6>
                    <ul className="footer-nav">
                      {typeObj.sector.slice(0, 3).map((sector, sectorIndex) => (
                        sector.tours.slice(0, 1).map((tour, tourIndex) => (
                          <li key={tourIndex} className="footer-nav-item" 
                              onClick={() => navigate(`allpackeges/${sector.sectorId}`, { state: { tourSectorId: tour.tour_sector_id } })}>
                            <div className="d-flex align-items-center cursor-pointer">
                              {/* <img src={getImageUrl(tour.image)} alt={tour.sector_name} className="mini-thumb" /> */}
                              <span className="dest-name">{tour.sector_name}</span>
                            </div>
                          </li>
                        ))
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </Col>

            {/* Column 4: Newsletter */}
            <Col lg={3} md={6}>
              <h5 className="footer-heading">Quick Links</h5>
              <ul className="footer-nav mb-4">
                <li><Link to="/moments">Our Moments</Link></li>
                <li><Link to="/blog">Our Blogs</Link></li>
                <li><Link to="/about-us">About Us</Link></li>
                <li><Link to="/contact-us">Contact Us</Link></li>
              </ul>
              {/* <p className="small opacity-75">Subscribe for travel updates:</p>
              <div className="modern-newsletter">
                <input type="email" placeholder="Email Address" />
                <button aria-label="Subscribe"><FaPaperPlane /></button>
              </div> */}
            </Col>
            
          </Row>
        </Container>
      </div>

      <div className="footer-legal-bar">
        <Container>
          <hr className="footer-divider" />
          <div className="legal-flex-container">
            <p className="copyright-text mb-0">© 2026 Radhe Shyam Group. All rights reserved.</p>
            <div className="legal-links">
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms & Conditions</Link>
            </div>
          </div>
        </Container>
      </div>
    </footer>
  );
};

export default FooterSection;